/**
 * Route for `spillover-handling`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { SpilloverHandlingPage } from "../features/spillover-handling/SpilloverHandlingPage";

export const spilloverHandlingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/spillover-handling",
	component: SpilloverHandlingPage,
});

export default spilloverHandlingRoute;
